(function () {
  const links = document.querySelectorAll('a[href^="https://www.google.com/maps?"],a[href^="https://google.com/maps?"],a[href^="http://google.com/maps?"]');

  const ua = navigator.userAgent;
  const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);

  links.forEach((link) => {
    // if (!isMobile) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener");
    // }

    // link.addEventListener("click", (e) => {
    //   if (!isMobile) return; // desktop uses normal Google Maps link

    //   const url = new URL(link.href);
    //   const query =
    //     url.searchParams.get("q") || url.pathname.replace("/maps", "");
    //   const enc = encodeURIComponent(query);

    //   const target = `geo:0,0?q=${enc}`;

    //   e.preventDefault();
    //   window.location.href = target;
    // });
  });
})();

(function () {
  const SELECTOR = '.quantity--with-unit .quantity__input';
  const MIN_CH = 1;
  const MAX_CH = 4;

  const fit = (input) => {
    const digits = String(input.value === '' ? input.min || 1 : input.value).length;
    input.style.width = Math.min(Math.max(digits, MIN_CH), MAX_CH) + 'ch';
  };

  const fitWithin = (node) => {
    if (node.nodeType !== 1) return;
    if (node.matches && node.matches(SELECTOR)) fit(node);
    if (node.querySelectorAll) node.querySelectorAll(SELECTOR).forEach(fit);
  };

  ['input', 'change'].forEach((type) =>
    document.addEventListener(type, (event) => {
      if (event.target.matches && event.target.matches(SELECTOR)) fit(event.target);
    })
  );

  fitWithin(document.body);

  // Quick view and variant changes inject fresh markup.
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(fitWithin));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
